import { Currency } from 'domains/models/service_price/currency';
import { TaxRateType } from 'domains/models/service_price/tax_rate_type';
import { z } from 'zod';

export const CurrencyEnum = z.nativeEnum(Currency);
export const TaxRateTypeEnum = z.nativeEnum(TaxRateType);
